import { render, staticRenderFns } from "./NewFormPrimaryAdd.vue?vue&type=template&id=2dc86bd7"
import script from "./NewFormPrimaryAdd.vue?vue&type=script&lang=js"
export * from "./NewFormPrimaryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports